<template>
  <div id="helpCenter">
    <ul class="optionsContainer">
      <li class="item" v-for="item in helperDrawerOptions" :key="item.id">
        <div
          :class="helperDrawerSlected1==item.id?'itemTitleSlelcted':''"
          class="itemTitle"
          @click="handleSelect1(item)"
        >
          <span>{{item.showName}}</span>
          <img
            class="arrowDown"
            v-if="item.children && item.children.length>0"
            src="../../../../assets/image/arrDown.png"
            alt
          />
        </div>
        <div class="itemsBox" v-if="helperDrawerSlected1==item.id">
          <div
            @click="handleSelect2(items)"
            class="items"
            :class="helperDrawerSlected2==items.id?'itemsTitleSlelcted':''"
            v-for="items in item.children"
            :key="items.id"
          >{{items.title}}</div>
        </div>
      </li>
    </ul>
    <div class="helpContainer">
      <div style="width:100%;height:100%;overflow-y: auto;">
        <div class="title" v-if="helpDetails && helpDetails.title">{{helpDetails.title}}</div>
        <div
          class="time"
          v-if="helpDetails && helpDetails.show_time"
        >{{'最后更新时间：'+helpDetails.show_time}}</div>
        <div
          class="content"
          style="width:100%;"
          v-if="helpDetails && helpDetails.content"
          v-html="helpDetails.content"
        ></div>
      </div>
    </div>
  </div>
</template> 
<script>
export default {
  name: 'helpCenter',
  data() {
    return {
      helperDrawerSlected1: '',
      helperDrawerSlected2: '',
      helperDrawerOptions: [],
      member_id: '',
      token: '',
      company_id: '',
      cache_department_id: '',
      helpDetails: {},
    }
  },

  methods: {
    // 父级
    handleSelect1(item) {
      this.helperDrawerSlected1 = item.id
      if (item.children && item.children.length > 0) return
      this.getHelpDetails(item.id)
    },
    // 子级
    handleSelect2(item) {
      this.helperDrawerSlected2 = item.id
      this.getHelpDetails(item.id)
    },
    // *获取使用帮助列表
    async getHelpList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('type', '1')

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Help/index',
        data: param,
      })
      if (res.code != 200) {
        return this.$message.error(res.datas.msg)
      }
      this.helperDrawerOptions = res.datas.listInfo
      console.log('帮助中心', this.helperDrawerOptions)
    },
    // *获取使用帮助详情
    async getHelpDetails(id) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('help_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Help/detail',
        data: param,
      })
      if (res.code != 200) {
        return this.$message.error(res.datas.msg)
      }
      this.helpDetails = res.datas.info
      this.contentShow = true
      console.log('帮助详情', this.helpDetails)
    },
  },
  activated() {},
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getHelpList()
    // if (this.$route.query && this.$route.query.id) {
    //   this.getHelpDetails(this.$route.query.id)
    // }
  },
  watch: {
    '$route.query.id': function () {
      this.getHelpDetails(this.$route.query.id)
    },
  },
}
</script>
<style lang="less" scoped>
#helpCenter {
  box-sizing: border-box;
  padding: 30px;
  padding-left: 260px;
  height: 100%;
  .helpContainer {
    border-radius: 10px;
    box-shadow: 1px 5px 9px 0px rgb(3 70 126 / 14%);
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px 30px;
    // text-align: center;
    .title {
      margin-bottom: 10px;
      font-size: 22px;
      color: #333;
    }
    .time {
      margin: 20px;
      font: 14px;
      color: #999;
    }
    .content {
      font-size: 12px;
      color: #9e9e9e;
      width: 100%;
    }
  }
}
// 帮助说明
.optionsContainer {
  position: absolute;
  left: 230px;
  // animation: none;
  background-color: #fff;
  width: 230px;
  height: 92%;
  top: 8%;
  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3);
  overflow-y: auto;

  .item {
    width: 100%;
  }
  .itemTitle {
    cursor: pointer;
    position: relative;
    font-size: 18px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #333;
    height: 42px;
    display: flex;
    align-items: center;
    padding-left: 17px;
    width: 100%;
    box-sizing: border-box;
    .arrowDown {
      width: 14px;
      position: absolute;
      right: 20px;
    }
  }
  .itemTitle::before {
    content: '';
    // width: 20px;
    // height: 20px;
    // background-color: #d8d8d8;
    // margin-right: 10px;
  }
  .itemsBox {
    animation: ltr-drawer-in 0.3s 1ms;
  }
  .items {
    cursor: pointer;
    display: flex;
    align-items: center;

    height: 42px;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    padding-left: 23px;
  }
  .items::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #d8d8d8;
    margin-right: 16px;
  }
  .itemTitleSlelcted {
    background: #3a9ef4;
    color: #fff;
  }
  .itemsTitleSlelcted {
    color: #3a9ef4;
  }
  .itemsTitleSlelcted::before {
    background-color: #3a9ef4;
  }
}
</style>
